/**
 * Ad Broadcast Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 

export enum OfferType {

      Demonstration = 0,
      EmployeesCar = 1,
      New = 2,
      Antique = 3,
      PreRegistered = 4,
      Used = 5,

};
